const changelog = [
  {
    version: '3.44.0',
    releaseDate: '05.11.2026',
    new: [
      {
        title: 'Overall Status data source',
        description: 'In Asset Management, the "Overall Status" widget of Waves and Deployments now has a toggle to choose the data source: FOTA Lifecycle (default) or KPI. The chart and the Done / Error / In progress table update instantly when you switch. Waves with several deployments show a per-deployment chart that follows the same toggle. KPI is not available in the China data region, so FOTA Lifecycle is used there.',
      },
      {
        title: 'Asset upload in China',
        description: 'Uploading assets from a package now works in the China data region. The files are stored in China, like the rest of the China data. Before, the upload failed with a technical error.',
      },
    ],
    updated: [
      {
        title: 'Network access from Nestlé USA',
        description: 'Users on the Nestlé USA corporate network can now reach the Portal without being blocked.',
      },
    ],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/browse/CONIOTPOR-445',
  },
  {
    version: '3.43.0',
    releaseDate: '04.11.2026',
    new: [],
    updated: [
      {
        title: 'API Credentials: all your credentials',
        description: 'The API Credentials page now lists every credential of your projects, including those without a quota, and the page banner subtitle is shown correctly.',
      },
      {
        title: 'Network access request form',
        description: 'The network restriction message now links to the ServiceNow request form "IoT Portal API Network Access Request" in every environment.',
      },
    ],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/browse/CONIOTPOR-512',
  },
  {
    version: '3.42.1',
    releaseDate: '14.10.2026',
    new: [],
    updated: [
      {
        title: 'Network access request form',
        description: 'The request form linked from the network restriction message now belongs to a shared team account, so every request is reviewed by the IoT Portal team and does not depend on one person.',
      },
    ],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/browse/CONIOTPOR-485',
  },
  {
    version: '3.42.0',
    releaseDate: '13.10.2026',
    new: [
      {
        title: 'Network restriction message',
        description: 'When you sign in from a network that is not allowed to reach the IoT Portal, the Portal now shows a clear message instead of failing with errors. It explains the two ways forward: connect to the Nestlé office network or VPN and choose "Try again", or request that your IP address or range is whitelisted with the request form. Partners and vendors are told to ask their Nestlé sponsor for a guest account first. Once access is back, the Portal loads without signing in again.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/browse/CONIOTPOR-485',
  },
  {
    version: '3.41.0',
    releaseDate: '02.10.2026',
    new: [],
    updated: [
      {
        title: 'New Raw Data Message Types',
        description: 'The Message Types filter on the Device Raw Data page now includes topics 31 (Device to Backend Pooling operations), 32 (Ecosystem topic to send commands from the Hub to the accessory) and 33 (Ecosystem topic for the accessory to notify the status to the Hub).',
      },
    ],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/browse/CONIOTPOR-455',
  },
  {
    version: '3.40.2',
    releaseDate: '08.09.2026',
    new: [],
    updated: [],
    fix: [
      {
        title: 'Create New User Works Again',
        description: 'In User Management, the "Create New User" button opened an information window that did nothing. It now opens the create form again, so you can register a person by email and grant them project roles before their first login. The screen also explains the correct order: create the account and assign roles first, then the person signs in with SSO and inherits those roles automatically.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.40.1',
    releaseDate: '04.09.2026',
    new: [],
    updated: [],
    fix: [
      {
        title: 'Editable Deployment Comment',
        description: 'Deployment details now let you edit the deployment comment directly from the Portal, matching the existing Wave description editing behavior — no need to call the platform API directly.',
      },
    ],
    urlDocumentation: 'https://nestle.atlassian.net/browse/CONIOTPOR-436',
  },
  {
    version: '3.40.0',
    releaseDate: '16.07.2026',
    new: [
      {
        title: 'Manage Policy Templates',
        description: 'New "Policy Templates" screen (Certificate Management section) lets platform admins create, view, edit, and delete IAM policy templates used to grant credential permissions — including a JSON editor for the permission policy (validated for syntax and structure) and a Services multi-select. Also includes a Variables tab for managing the {{VARIABLE}} placeholders templates can reference, plus a guided tutorial and written help guide. Templates and credentials are now cross-linked: the template form has a "+ New Variable" shortcut, and Credentials Management\u2019s APIs/Permissions pickers link back to Policy Templates.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.39.0',
    releaseDate: '16.07.2026',
    new: [
      {
        title: 'Edit Credential Project/Brand',
        description: 'Credential Details\u2019 Products field is now editable \u2014 add or remove the projects/brands a credential belongs to. Changing it shows a change request ID with a "Check status" button to track IAM policy propagation, and the change is audit-logged.',
      },
    ],
    updated: [
      {
        title: 'Multi-select Dropdowns Show a Compact Summary',
        description: 'When many options are selected (e.g. a credential with 20+ products), dropdowns now show "N selected: ..." instead of listing every label, which previously wrapped across several lines and looked broken.',
      },
    ],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.38.0',
    releaseDate: '16.07.2026',
    new: [
      {
        title: 'Credential Expiration Alerts',
        description: 'Credentials Management now shows an expiration status (OK, Expiring soon, Expired, or No expiry) for every credential, in both the list and the details view. Filter the list by expiration status, or click the "Expiration" column header to sort by how soon each credential expires.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.37.0',
    releaseDate: '16.07.2026',
    new: [],
    updated: [
      {
        title: 'Guided Tutorial Redesigned by Topic',
        description: 'The Credentials Management guided tutorial now opens on a topic menu (Creating Credentials, Finding Credentials, Viewing \u0026 Editing Details, Rotating \u0026 Cleaning Up Keys, Managing API Permissions, Other Credential Actions) so you can jump straight to what you need instead of clicking through every step. It also now covers the Credential Details modal\u2019s contents (Access Keys, Enable, Permissions), not just the list view.',
      },
      {
        title: 'Help Button Opens the Tutorial First',
        description: 'The "?" Help button now opens the guided tutorial directly; the written Quick Guide is available as a secondary link from the tutorial\u2019s topic menu.',
      },
    ],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.36.0',
    releaseDate: '16.07.2026',
    new: [
      {
        title: 'Enable Disabled Credentials',
        description: 'Credential Details now shows a banner and an Enable action when a credential has no active access key, letting you re-enable it directly from the Portal.',
      },
      {
        title: 'Manage a Credential\u2019s API Permissions',
        description: 'Credential Details now includes a Permissions section listing the APIs currently granted to a credential, with the ability to add new APIs or remove existing ones (Certificate Provisioning remains an exclusive choice).',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.35.0',
    releaseDate: '16.07.2026',
    new: [
      {
        title: 'Selectable APIs for New Credentials',
        description: 'When requesting a new credential, you can now choose exactly which APIs it should have access to from the full list of available permission templates, instead of a fixed default set. Certificate Provisioning is kept as an exclusive selection since it cannot be combined with other APIs.',
      },
    ],
    updated: [
      {
        title: 'New Credential Success Screen',
        description: 'Added a documentation link on the screen shown after creating a credential, alongside the existing access key/secret display and CSV download.',
      },
    ],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.34.0',
    releaseDate: '15.07.2026',
    new: [
      {
        title: 'Confirm Rotation & Remove Old Access Key',
        description: 'After rotating credentials, you can now confirm the new key works and remove the old one directly from the credential\u2019s details. The Access Keys section shows each key\u2019s status and last-used date, and warns you if the key you\u2019re about to remove was used within the last 24 hours.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.33.0',
    releaseDate: '15.07.2026',
    new: [
      {
        title: 'Rotate Credentials',
        description: 'Users can now trigger on-demand credential rotation directly from Credentials Management, generating a fresh access key and secret without needing to contact support. The new credentials are shown once with copy-to-clipboard and CSV download, matching the 365-day rotation policy.',
      },
      {
        title: 'Guided Tutorial for Credentials Management',
        description: 'A new "Start Guided Tutorial" option in the Help popup walks you step by step through every action on the Credentials Management page, highlighting each button as it explains what it does.',
      },
    ],
    updated: [
      {
        title: 'Credentials Management Help',
        description: 'Added a Help ("?") button on Credentials Management with a quick-reference guide to every action on the page, and a tooltip on the favorites (star) icon for consistency with the other actions.',
      },
    ],
    fix: [
      {
        title: 'Credential Rotation Permission',
        description: 'Fixed an issue where some administrators could not rotate credentials due to a missing permission.',
      },
      {
        title: 'Credential Rotation Error Message',
        description: 'Fixed an issue where a failed credential rotation (e.g. when a credential already has the maximum of 2 access keys) could show a technical error instead of a clear, actionable message.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.32.0',
    releaseDate: '18.06.2026',
    new: [
      {
        title: 'Device, Module, Gateway & Settings History',
        description: 'The Connectivity Status History screen now supports four new history listings in addition to the existing Connectivity history: Device, Module, Gateway and Settings (snapshot) history. Each context is powered by the historical telemetry API (reusing the secured IoTHubService integration), is scoped to the selected project, and supports pagination with clear empty-state handling. You can switch between them from a colorful selector placed between the presence graph and the table.',
      },
      {
        title: 'Connectivity History — Quick Context Switching',
        description: 'Changing the history selector (or the active module/gateway) refreshes the table automatically without needing a Search button, and the presence graph is preserved instead of reloading on every change. Changing the date range refreshes both the graph and the table.',
      },
      {
        title: 'Copyable Payload Summary',
        description: 'The Payload Summary column in the history table now truncates long values, shows the full content on hover, and provides a one-click copy-to-clipboard icon so complete payloads are no longer cut off.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.31.0',
    releaseDate: '02.06.2026',
    new: [
      {
        title: 'Collapsible Left Sidebar',
        description: 'Users can now collapse the left navigation sidebar to an icon-only mode, reclaiming horizontal screen space for data-dense views such as Device Consumptions, Device Events and Asset listings. The preference is remembered across sessions, hovering an icon shows its name, and clicking a section icon while collapsed automatically expands the sidebar and navigates to the first item the user has permission to access.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.30.0',
    releaseDate: '12.05.2026',
    new: [],
    updated: [
      {
        title: 'Credentials Management',
        description: 'Simplified credential deletion workflow by removing the disable functionality. Superadmins can now permanently delete credentials directly using a single action.',
      },
    ],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.29.0',
    releaseDate: '09.04.2026',
    new: [
      {
        title: 'Home Page',
        description: 'New home page implementation providing an improved landing experience for users.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.28.0',
    releaseDate: '02.03.2026',
    new: [
      {
        title: 'Presence History Graph',
        description: 'Added a visual presence history graph to the Connectivity Status History screen.',
      },
      {
        title: 'IOTA for KOTO',
        description: 'Chatbot is now available for KOTO project.',
      },
    ],
    updated: [
      {
        title: 'Interactive Tooltips',
        description: 'Tooltips showing date and connection status on hover in presence history graph.',
      },
      {
        title: 'Responsive Layout',
        description: 'Graph layout with horizontal scroll support on mobile devices.',
      },
    ],
    fix: [],
    urlDocumentation: '',
  },
  {
    version: '3.27.0',
    releaseDate: '02.02.2026',
    new: [],
    updated: [
      {
        title: 'Staged Deployment Improvements',
        description: 'More stable and predictable configuration process; system avoids unnecessary calculations and always reflects the latest setup; clear messaging when a calculation takes too long.',
      },
    ],
    fix: [
      {
        title: 'Concurrent API Calls',
        description: 'Resolved an issue that could trigger multiple calculations at once, improving overall system reliability.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.26.0',
    releaseDate: '21.01.2026',
    new: [
      {
        title: 'Data Dictionary Management',
        description: 'Users can now keep events, recipes & consumptions dictionaries updated in STAGING and release clean, human-readable data to PROD.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General Improvements',
        description: 'Minor bugs have been addressed.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.25.0',
    releaseDate: '24.11.2025',
    new: [
      {
        title: 'Canary Deployment Feature',
        description: 'This feature enables staged deployment of firmware updates for IoT devices, allowing for the identification and resolution of potential issues before they impact the entire fleet. It significantly enhances our FOTA capabilities, providing a safer and more efficient way to deploy assets.',
      },
      {
        title: 'Meet IOTA (Chatbot)',
        description: 'The introduction of the IOTA chatbot for the Vertuo and Moment projects aims to enhance user experience by providing immediate assistance and information regarding devices and answer frequently asked questions.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General Improvements',
        description: 'Minor bugs have been addressed to improve overall system performance.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.24.0',
    releaseDate: '28.10.2025',
    new: [
      {
        title: 'Project Dashboard',
        description: 'Two new dashboards are now available on the project landing page, providing insights into device connectivity, including active vs. inactive devices and active devices by market.',
      },
      {
        title: 'Product Images',
        description: 'The KOTO and Momento projects now feature machine images on the details page to enhance user experience.',
      },
      {
        title: 'Self-Service Account Deletion',
        description: 'Users can now delete their accounts directly if they no longer wish to access the portal.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General Improvements',
        description: 'Minor bugs have been addressed.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.23.0',
    releaseDate: '24.09.2025',
    new: [
      {
        title: 'Device Overview Landing page',
        description: 'This new landing page provides a list of devices within a project that recently experienced connectivity status changes. Users can now navigate to device details directly from this page, in addition to searching for specific devices.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Addressed minor bugs.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.22.0',
    releaseDate: '17.09.2025',
    new: [
      {
        title: 'Device Overview UI Redesign',
        description: 'The redesigned device overview page enhances user-friendliness for non-technical users and also introduces quick access to new information such as paired devices and notable events.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Addressed minor bugs to improve overall system stability and UX.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.21.0',
    releaseDate: '09.09.2025',
    new: [
      {
        title: 'MQTT Dashboard',
        description: 'Designed for users in telemetry and release management roles. Provides a comprehensive overview of MQTT analytics, allowing users to filter data by specific projects, provided they have the necessary permissions.',
      },
      {
        title: 'Bug Reporting Enhancement',
        description: 'Users can report bugs via the feedback tool in the portal by clicking the "Give Feedback" icon. Reported issues will automatically be sent to our development team for prompt action.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Addressed minor bugs to improve overall system stability and UX.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.20.0',
    releaseDate: '28.08.2025',
    new: [
      {
        title: 'Global Deployment Capabilities',
        description: 'Release Managers are now empowered to perform global deployments within the STAG environment.',
      },
      {
        title: 'Portal Usage Dashboard Events',
        description: 'Necessary events have been created to facilitate the development of the IoT Portal usage Dashboard, providing better insights into user engagement and system performance.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Addressed minor bugs to improve overall system stability and UX.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.19.0',
    releaseDate: '14.07.2025',
    new: [
      {
        title: 'Certificate Management Improvements',
        description: 'Users can request a quota increase and update credential details directly through the portal, with special permission as a certificate manager required for each brand.',
      },
      {
        title: 'Device Raw Data Page Updates',
        description: 'Users can now filter data by message direction and type, view the latest entries first, and see the "Reject Reason" only for invalid searches.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Resolved issues with pagination and CSV export failures to enhance user experience and system performance.',
      },
    ],
    urlDocumentation: '',
  },
  {
    version: '3.18.0',
    releaseDate: '10.06.2025',
    new: [
      {
        title: 'Saved Filters',
        description: 'Users can now create, save, and manage filters across the portal, providing quick access to frequently used options.',
      },
      {
        title: 'Favorite Projects',
        description: 'Users can now favorite their most frequently used projects in the dropdown list, ensuring they appear at the top for easy access.',
      },
      {
        title: 'User Management',
        description: 'Portal admins can create new user accounts and manage permissions directly from the portal.',
      },
      {
        title: 'Device Serial Number in URL',
        description: 'The device serial number has been added as a parameter in the URL, allowing users to exchange direct links pointing to specific device data.',
      },
    ],
    updated: [
      {
        title: 'Device Management',
        description: 'Improved device management screens to display only relevant information, enhancing clarity. The export function retains the original raw format.',
      },
    ],
    fix: [
      {
        title: 'General',
        description: 'Various bug fixes to enhance system stability and performance.',
      },
    ],
    urlDocumentation: 'https://nestle.atlassian.net/projects/DII/versions/78865/tab/release-report-all-issues',
  },
  {
    version: '3.17.0',
    releaseDate: '12.05.2025',
    new: [
      {
        title: 'Device Management',
        description: 'The device consumptions, raw data and settings tables have been redesigned to display only the most relevant information for users, enhancing clarity and usability. Despite this improvement, please note that the export function will still generate the table in its original raw format.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Bug Fixes',
      },
    ],
    urlDocumentation: 'https://nestle.atlassian.net/wiki/spaces/DIIS/pages/444400667/IoT+Portal+3.17.0',
  },
  {
    version: '3.16.0',
    releaseDate: '07.04.2025',
    new: [
      {
        title: 'Device Events',
        description: 'The device events table has been redesigned to display only the most relevant information for users, enhancing clarity and usability. Despite this improvement, please note that the export function will still generate the table in its original raw format.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Bug Fixes',
      },
    ],
    urlDocumentation: 'https://nestle.atlassian.net/wiki/spaces/DIIS/pages/420874795/IoT+Portal+3.16.0',
  },
  {
    version: '3.15.0',
    releaseDate: '18.03.2025',
    new: [
      {
        title: 'Device Overview',
        description: ' Users can now view all relevant information about a specific device in one consolidated page. The new feature eliminates the need for users to navigate through multiple pages and repeatedly enter the device serial number. This streamlines the process and saves time, enabling users to quickly access the information they need. This release includes new device information: connectivity status, connectivity history and shadow wrapper.',
      },
      {
        title: 'Enhanced Device Consumptions and Events search',
        description: 'A new toggle feature has been implemented for those searches, allowing users to select between machine\'s timestamp and processed timestamp. This improves search accuracy and provides guidance when no results are found due to incorrect machine timestamps.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/wiki/spaces/DIIS/pages/407012023/IoT+Portal+3.15.0',
  },
  {
    version: '3.14.0',
    releaseDate: '11.02.2025',
    new: [
      {
        title: 'Fine-grained permissions',
        description: 'The implementation of this feature enhances security by restricting developers from deploying firmware to specific devices. This ensures new firmware is validated on a limited scope, minimizing the risk of widespread device malfunctions. Additionally, telemetry access is restricted to maintain consistency and protect sensitive data.',
      },
    ],
    updated: [],
    fix: [],
    urlDocumentation: 'https://nestle.atlassian.net/wiki/spaces/DIIS/pages/370936723/IoT+Portal+3.14.0',
  },
  {
    version: '3.13.0',
    releaseDate: '20.01.2025',
    new: [
      {
        title: 'IoT Platform Health',
        description: 'Admin users now have the capability to monitor the Platform Health directly within the Portal.',
      },
    ],
    updated: [
      {
        title: 'ServiceNow form',
        description: 'The "New IoT Asset Version Analysis and Asset Deployment" ServiceNow form has been enhanced and is now available in the Service Request menu.',
      },
      {
        title: 'Incident reporting',
        description: 'A "Raise an Incident" link has been added to the Service Request menu, allowing users to easily redirect to ServiceNow to raise an incident directly from the Portal.',
      },
    ],
    fix: [],
  },
  {
    version: '3.12.0',
    releaseDate: '17.12.2024',
    new: [
      {
        title: 'Simulated Client as a Service',
        description: 'Users can now simulate MQTT messages from device to cloud. This new feature offers a great support to the development integration activities.',
      },
    ],
    updated: [],
    fix: [
      {
        title: 'General',
        description: 'Bug Fixes',
      },
    ],
  },
  {
    version: '3.11.0',
    releaseDate: '27.11.2024',
    new: [],
    updated: [
      {
        title: 'Error messages',
        description: 'Conveying of error messages from the platform APIs is update all across the Portal.',
      },
    ],
    fix: [
      {
        title: 'Bundles',
        description: 'Bug Fixes in Bundles',
      },
      {
        title: 'Waves',
        description: 'Bug Fixes in Waves',
      },
    ],
  },
  {
    version: '3.10.0',
    releaseDate: '30.10.2024',
    new: [
      {
        title: 'Waves',
        description: 'A wave entity is created for deployment of assets or asset bundles which increases traceability. User is able to delete all deployments associated with the wave in one transaction.',
      },
    ],
    updated: [],
    fix: [],
  }
];

export default changelog;
